var map = {
	"./android-chrome-192x192.png": "./src/img/android-chrome-192x192.png",
	"./android-chrome-512x512.png": "./src/img/android-chrome-512x512.png",
	"./apple-touch-icon.png": "./src/img/apple-touch-icon.png",
	"./bg-overlay.png": "./src/img/bg-overlay.png",
	"./brut/brut-bg.jpg": "./src/img/brut/brut-bg.jpg",
	"./brut/brut-dashicon.png": "./src/img/brut/brut-dashicon.png",
	"./brut/brut-icon.png": "./src/img/brut/brut-icon.png",
	"./brut/brut-logo-white.png": "./src/img/brut/brut-logo-white.png",
	"./brut/brut-logo.png": "./src/img/brut/brut-logo.png",
	"./check-light.svg": "./src/img/check-light.svg",
	"./check.svg": "./src/img/check.svg",
	"./dienstverband.svg": "./src/img/dienstverband.svg",
	"./favicon-16x16.png": "./src/img/favicon-16x16.png",
	"./favicon-32x32.png": "./src/img/favicon-32x32.png",
	"./favicon.ico": "./src/img/favicon.ico",
	"./footer-image.svg": "./src/img/footer-image.svg",
	"./leeftijd.svg": "./src/img/leeftijd.svg",
	"./locatie.svg": "./src/img/locatie.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./site.webmanifest": "./src/img/site.webmanifest"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";